import { UtensilsCrossed, Store, MapPinned } from "lucide-react";
import { useLang } from "@/i18n";
import Reveal, { SectionHead } from "./Reveal";

const IMAGES = [
  "https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=1200&q=85",
];
const ICONS = [UtensilsCrossed, Store, MapPinned];
const TEST_IDS = ["benefit-card-restaurant", "benefit-card-retail", "benefit-card-services"];

export default function Benefits() {
  const { t } = useLang();
  return (
    <section id="benefits" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <SectionHead
          badge={t.benefits.badge}
          title={t.benefits.title}
          sub={t.benefits.sub}
          testId="benefits-title"
        />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {t.benefits.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={card.title} delay={i * 0.12}>
                <article
                  data-testid={TEST_IDS[i]}
                  className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-[#0b0f19] transition-colors duration-500 hover:border-cyan-400/40"
                >
                  <div className="relative h-52 sm:h-56 overflow-hidden">
                    <img
                      src={IMAGES[i]}
                      alt={card.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0b0f19] via-[#0b0f19]/20 to-transparent" />
                    <span className="absolute top-4 right-5 font-mono-accent text-4xl font-semibold text-white/10 group-hover:text-cyan-400/25 transition-colors duration-500">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="relative p-7 pt-0">
                    <div className="-mt-9 mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border border-cyan-400/30 bg-[#030712] shadow-[0_0_24px_rgba(0,240,255,0.15)]">
                      <Icon className="w-6 h-6 text-cyan-300" />
                    </div>
                    <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight">{card.title}</h3>
                    <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">{card.desc}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
